export default __webpack_public_path__ + "static/group-20690-beafd0cce601be469c4120fbecb1d1ce.png";